module.exports = __webpack_public_path__ + "static/media/p_mobilnik.8a903874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay/p_mobilnik.png
// module id = 2438
// module chunks = 7